import { Amenity, StayContent, StayFacilityType } from '../../src/types/StayContent.types';
import { Builder } from 'builder-pattern';

const StayFacilityFactory = (type: StayFacilityType, str: string) =>
  Builder<StayContent['facilities'][number]>().type(type).description(str).build();

const FacilityGenerator = (facilities: string[]) => {
  return facilities.map((facility) => StayFacilityFactory(StayFacilityType.HotelFacility, facility));
};

const AdelaideRivieraHotelStay = ({
  stayId = '4277677',
  hotelName = 'Adelaide Riviera Hotel',
  rating = 4,
  checkInTime = '14:00',
  checkOutTime = '10:00',
  location = Builder<StayContent['location']>().coordinates({ lat: -34.9221, lon: 138.5897 }).build(),
  address = Builder<StayContent['address']>()
    .line_1('31 34 North Terrace')
    .city('Adelaide')
    .state('SA')
    .country('Australia')
    .postcode('5000')
    .countryCode('AU')
    .build(),
  slug = '/au-sa-adelaide/adelaide-riviera-hotel-4277677',
  createdTime = '2022-08-18T22:00:32.621Z',
  updatedTime = '2022-08-18T22:08:27.669Z',
  descriptions = [
    Builder<StayContent['descriptions'][number]>()
      .language('en')
      .title('')
      .detail(
        "LocationCentrally located on Adelaide's cultural boulevard, the North Terrace, this hotel is situated within an easy walk of Rundle Mall, theatres, Festival Centre and the casino. It is the closest accommodation to Adelaide Entertainment Centre.FacilitiesThe establishment features various services and facilities for a comfortable and relaxing stay, including internet access, wireless internet access, a restaurant, a café and a laundry. Guests arriving in their own vehicles can park in the car park for a fee.RoomsSpecial family rooms are available for families with children. All accommodation units feature air conditioning, central heating and a bathroom. Guests will also find a balcony in most accommodation units. A minibar is among the amenities in all rooms. In addition, a fridge, a mini-fridge and tea and coffee making equipment are available. An ironing set is also available to guests. Convenient features include internet access, a telephone, a TV, a radio and wireless internet access. In the bathrooms, guests will find a shower, a spa bath and a hairdryer. MealsThe establishment offers breakfast as a bookable board option.",
      )
      .build(),
  ],
  facilities = [
    'Free Wifi',
    'Family rooms',
    'Non smoking rooms',
    'Parking',
    'Wifi',
    'Garden',
    'Internet access',
    'Express check in',
    'Playground',
    'Air conditioning',
    'Smoking area',
    'Terrace',
    'Housekeeping',
    'TV',
    'Cleaning',
    'Laundry Service',
    'Safe',
    'First aid',
    'Bars',
    'Breakfast',
    'Shower',
    'Toiletries',
    'Fan',
    'WC',
    'Bathroom',
    'Towels',
  ],
  images = [
    {
      url: 'https://az712897.vo.msecnd.net/images/full/ce0dc13b-de63-40c9-b43a-c6475262f02f.jpeg',
      description: 'Featured Image',
    },
  ] as StayContent['images'],
  amenities = [
    'Free WiFi',
    'Smoke free property',
    'Parking',
    'Spa',
    'Concierge services',
    'Restaurant',
    'Child minding',
    'Laundry',
    'Accessible',
    'Maid services',
    'Bar',
  ] as Amenity[],
  mappedDescriptions = {} as Record<string, string[]>,
}): StayContent =>
  Builder<StayContent>()
    .hotelId(stayId)
    .hotelName(hotelName)
    .rating(rating)
    .checkInTime(checkInTime)
    .checkOutTime(checkOutTime)
    .hotelLogo('')
    .location(location)
    .address(address)
    .slug(slug)
    .createdTime(createdTime)
    .updatedTime(updatedTime)
    .descriptions(descriptions)
    .facilities(FacilityGenerator(facilities))
    .images(
      images.map((image) =>
        Builder<StayContent['images'][number]>().url(image.url).description(image.description).build(),
      ),
    )
    .mappedDescriptions(mappedDescriptions)
    .amenities(amenities)
    .build();

export default AdelaideRivieraHotelStay;

export const StayContentMock_2 = AdelaideRivieraHotelStay({
  stayId: '16977785',
  hotelName: 'Soda Apartment',
  rating: 3,
  location: {
    coordinates: {
      lat: -27.4752,
      lon: 153.0149,
    },
  },
  address: {
    line_1: '27 Cordelia St',
    city: 'South Brisbane',
    state: 'QLD',
    country: 'Australia',
    postcode: '4101',
    countryCode: 'AU',
  },
  slug: '/au-qld-south-brisbane/soda-apartment-16977785',
  createdTime: '2022-08-25T22:01:46.676Z',
  updatedTime: '2022-08-25T22:05:22.768Z',
  descriptions: [
    {
      language: 'en',
      title: 'amenities',
      detail:
        "Don't miss out on recreational opportunities including an outdoor pool and a fitness center. Additional features at this apartment include complimentary wireless Internet access and barbecue grills.",
    },
    {
      language: 'en',
      title: 'renovations',
      detail:
        'The following facilities or services will be unavailable from October 25 2021 to September 1 2022 (dates subject to change):',
    },
    {
      language: 'en',
      title: 'renovations',
      detail: 'Fitness facilities',
    },
    {
      language: 'en',
      title: 'business amenities',
      detail: 'Featured amenities include luggage storage and an elevator. Free self parking is available onsite.',
    },
    {
      language: 'en',
      title: 'rooms',
      detail:
        "Make yourself comfortable in this individually decorated apartment, featuring a kitchen with a full-sized refrigerator/freezer and an oven. There's a private balcony. Complimentary wireless Internet access keeps you connected, and a Smart television is provided for your entertainment. Conveniences include a desk and complimentary newspapers, and you can also request a crib/infant bed (surcharge).",
    },
    {
      language: 'en',
      title: 'attractions',
      detail: 'Distances are displayed to the nearest 0.1 mile and kilometer.',
    },
    {
      language: 'en',
      title: 'attractions',
      detail: 'Queensland Museum - 0.4 km / 0.3 mi',
    },
    {
      language: 'en',
      title: 'attractions',
      detail: 'Queensland Art Gallery - 0.4 km / 0.3 mi',
    },
    {
      language: 'en',
      title: 'attractions',
      detail: 'South Bank Parklands - 0.5 km / 0.3 mi',
    },
    {
      language: 'en',
      title: 'attractions',
      detail: 'Queensland Performing Arts Centre - 0.6 km / 0.4 mi',
    },
    {
      language: 'en',
      title: 'attractions',
      detail: 'State Library of Queensland - 0.6 km / 0.4 mi',
    },
    {
      language: 'en',
      title: 'attractions',
      detail: 'Brisbane Convention and Exhibition Centre - 0.6 km / 0.4 mi',
    },
    {
      language: 'en',
      title: 'attractions',
      detail: 'Brisbane Brewing Co. - 0.7 km / 0.4 mi',
    },
    {
      language: 'en',
      title: 'attractions',
      detail: 'Gallery of Modern Art - 0.7 km / 0.5 mi',
    },
    {
      language: 'en',
      title: 'attractions',
      detail: 'Wheel of Brisbane - 0.8 km / 0.5 mi',
    },
    {
      language: 'en',
      title: 'attractions',
      detail: 'Treasury Casino - 1 km / 0.6 mi',
    },
    {
      language: 'en',
      title: 'attractions',
      detail: 'Streets Beach - 1.1 km / 0.7 mi',
    },
    {
      language: 'en',
      title: 'attractions',
      detail: 'Southbank Parklands - 1.1 km / 0.7 mi',
    },
    {
      language: 'en',
      title: 'attractions',
      detail: 'North Quay - 1.2 km / 0.7 mi',
    },
    {
      language: 'en',
      title: 'attractions',
      detail: 'Queen Street Mall - 1.3 km / 0.8 mi',
    },
    {
      language: 'en',
      title: 'attractions',
      detail: 'Museum of Brisbane - 1.4 km / 0.8 mi',
    },
    {
      language: 'en',
      title: 'attractions',
      detail: 'The nearest major airport is Brisbane Airport (BNE) - 18.9 km / 11.8 mi',
    },
    {
      language: 'en',
      title: 'location',
      detail:
        'Located in Brisbane (South Brisbane), this apartment is within a 10-minute drive of XXXX Brewery and Suncorp Stadium. This apartment is 1.5 mi (2.5 km) from Roma Street Parkland and 5.8 mi (9.3 km) from Brisbane Cruise Terminal.',
    },
    {
      language: 'en',
      title: 'headline',
      detail: 'In Brisbane (South Brisbane)',
    },
    {
      language: 'en',
      title: 'checkin instructions',
      detail: 'Extra-person charges may apply and vary depending on property policy',
    },
    {
      language: 'en',
      title: 'checkin instructions',
      detail:
        'Government-issued photo identification and a credit card may be required at check-in for incidental charges',
    },
    {
      language: 'en',
      title: 'checkin instructions',
      detail:
        'Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed',
    },
    {
      language: 'en',
      title: 'checkin instructions',
      detail: 'Guests must contact this property in advance to reserve cribs/infant beds',
    },
    {
      language: 'en',
      title: 'checkin instructions',
      detail: 'This property accepts credit cards; cash is not accepted',
    },
    {
      language: 'en',
      title: 'checkin instructions',
      detail: 'Onsite parties or group events are strictly prohibited',
    },
    {
      language: 'en',
      title: 'checkin instructions',
      detail:
        'Be prepared: check the latest COVID-19 travel requirements and measures in place for this destination before you travel.',
    },
    {
      language: 'en',
      title: 'checkin special instructions',
      detail:
        "There is no front desk at this property. This property doesn't offer after-hours check-in. Guests will receive an email 24 hours before arrival with check-in instructions and lockbox information. Guests can access their accommodation through a private entrance.",
    },
    {
      language: 'en',
      title: 'mandatory fees',
      detail: "You'll be asked to pay the following charges at the property:",
    },
    {
      language: 'en',
      title: 'mandatory fees',
      detail: 'Deposit: AUD 300 per stay',
    },
    {
      language: 'en',
      title: 'mandatory fees',
      detail: 'We have included all charges provided to us by the property.',
    },
  ],
  facilities: ['Free Wifi', 'Free car parking', 'Outdoor pool', 'Terrace', 'Luggage storage', 'Lifts'],
  images: [
    {
      url: 'https://az712897.vo.msecnd.net/images/full/b0b05db8-b821-447a-901e-7c05e74a2343.jpeg',
      description: 'Featured Image',
    },
    {
      url: 'https://az712897.vo.msecnd.net/images/full/6bb7af9c-5891-4ac1-9651-ff154b38368e.jpeg',
      description: 'Room',
    },
    {
      url: 'https://az712897.vo.msecnd.net/images/full/14f217f2-7d75-4d0d-996b-df3ca4acfa8e.jpeg',
      description: 'Room',
    },
    {
      url: 'https://az712897.vo.msecnd.net/images/full/08f7de9a-b083-4bd7-8c87-11d5c72e75df.jpeg',
      description: 'Room',
    },
    {
      url: 'https://az712897.vo.msecnd.net/images/full/339054cd-b7fb-4329-b2d6-880193de0a96.jpeg',
      description: 'In-Room Dining',
    },
    {
      url: 'https://az712897.vo.msecnd.net/images/full/c3c20599-2db7-433f-8ea7-619941525c81.jpeg',
      description: 'Private Kitchen',
    },
    {
      url: 'https://az712897.vo.msecnd.net/images/full/17fa8ca7-01e7-4f8e-99fb-057926f41313.jpeg',
      description: 'Private Kitchen',
    },
    {
      url: 'https://az712897.vo.msecnd.net/images/full/adebb44a-5191-4e4c-b2f9-d2a301b5afc7.jpeg',
      description: 'Private Kitchen',
    },
    {
      url: 'https://az712897.vo.msecnd.net/images/full/8bc7cc21-8778-4a8e-b42a-0c4f63f1b14d.jpeg',
      description: 'Living Area',
    },
    {
      url: 'https://az712897.vo.msecnd.net/images/full/2e89e250-b274-4068-9a67-016731f3adf8.jpeg',
      description: 'Balcony',
    },
    {
      url: 'https://az712897.vo.msecnd.net/images/full/8ed3efd7-2259-4da9-9759-25b34b7a28dc.jpeg',
      description: 'Balcony',
    },
    {
      url: 'https://az712897.vo.msecnd.net/images/full/38b27616-e164-4b18-bd1b-6071cc834db7.jpeg',
      description: 'Bathroom',
    },
    {
      url: 'https://az712897.vo.msecnd.net/images/full/7974fc4e-00a9-481d-88c2-f462d52f23cb.jpeg',
      description: 'Bathroom',
    },
    {
      url: 'https://az712897.vo.msecnd.net/images/full/e0eecce0-895e-48f2-966f-beaaf103584b.jpeg',
      description: 'Bathroom Amenities',
    },
    {
      url: 'https://az712897.vo.msecnd.net/images/full/8c1381e7-c446-43d0-893d-40669565a7f7.jpeg',
      description: 'City View from Property',
    },
  ],
  mappedDescriptions: {
    amenities: [
      "Don't miss out on recreational opportunities including an outdoor pool and a fitness center. Additional features at this apartment include complimentary wireless Internet access and barbecue grills.",
    ],
    renovations: [
      'The following facilities or services will be unavailable from October 25 2021 to September 1 2022 (dates subject to change):',
      'Fitness facilities',
    ],
    'business amenities': [
      'Featured amenities include luggage storage and an elevator. Free self parking is available onsite.',
    ],
    rooms: [
      "Make yourself comfortable in this individually decorated apartment, featuring a kitchen with a full-sized refrigerator/freezer and an oven. There's a private balcony. Complimentary wireless Internet access keeps you connected, and a Smart television is provided for your entertainment. Conveniences include a desk and complimentary newspapers, and you can also request a crib/infant bed (surcharge).",
    ],
    attractions: [
      'Distances are displayed to the nearest 0.1 mile and kilometer.',
      'Queensland Museum - 0.4 km / 0.3 mi',
      'Queensland Art Gallery - 0.4 km / 0.3 mi',
      'South Bank Parklands - 0.5 km / 0.3 mi',
      'Queensland Performing Arts Centre - 0.6 km / 0.4 mi',
      'State Library of Queensland - 0.6 km / 0.4 mi',
      'Brisbane Convention and Exhibition Centre - 0.6 km / 0.4 mi',
      'Brisbane Brewing Co. - 0.7 km / 0.4 mi',
      'Gallery of Modern Art - 0.7 km / 0.5 mi',
      'Wheel of Brisbane - 0.8 km / 0.5 mi',
      'Treasury Casino - 1 km / 0.6 mi',
      'Streets Beach - 1.1 km / 0.7 mi',
      'Southbank Parklands - 1.1 km / 0.7 mi',
      'North Quay - 1.2 km / 0.7 mi',
      'Queen Street Mall - 1.3 km / 0.8 mi',
      'Museum of Brisbane - 1.4 km / 0.8 mi',
      'The nearest major airport is Brisbane Airport (BNE) - 18.9 km / 11.8 mi',
    ],
    location: [
      'Located in Brisbane (South Brisbane), this apartment is within a 10-minute drive of XXXX Brewery and Suncorp Stadium. This apartment is 1.5 mi (2.5 km) from Roma Street Parkland and 5.8 mi (9.3 km) from Brisbane Cruise Terminal.',
    ],
    headline: ['In Brisbane (South Brisbane)'],
    'checkin instructions': [
      'Extra-person charges may apply and vary depending on property policy',
      'Government-issued photo identification and a credit card may be required at check-in for incidental charges',
      'Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed',
      'Guests must contact this property in advance to reserve cribs/infant beds',
      'This property accepts credit cards; cash is not accepted',
      'Onsite parties or group events are strictly prohibited',
      'Be prepared: check the latest COVID-19 travel requirements and measures in place for this destination before you travel.',
    ],
    'checkin special instructions': [
      "There is no front desk at this property. This property doesn't offer after-hours check-in. Guests will receive an email 24 hours before arrival with check-in instructions and lockbox information. Guests can access their accommodation through a private entrance.",
    ],
    'mandatory fees': [
      "You'll be asked to pay the following charges at the property:",
      'Deposit: AUD 300 per stay',
      'We have included all charges provided to us by the property.',
    ],
  },
  amenities: ['Free WiFi', 'Parking', 'Pool', 'Accessible'],
});
